import { styled } from "@mui/material";

export const ErrorContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  background: `linear-gradient(to right, ${theme.palette.primary.errorGradient1}, ${theme.palette.primary.errorGradient2})`,
  width: "100%",
  height: "100vh",
  overflow: "hidden",
  borderBottom: `1px solid ${theme.palette.primary.grey}`,
  "& a": {
    textDecoration: "none",
  },
}));

export const TextContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  borderTop: `1px solid ${theme.palette.primary.grey}`,
  borderBottom: `1px solid ${theme.palette.primary.grey}`,
  [theme.breakpoints.down("md")]: {
    border: "none",
  },
}));

export const ErrorImage = styled("img")(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    width: 620,
  },
  [theme.breakpoints.down("md")]: {
    width: 350,
  },
  [theme.breakpoints.down("sm")]: {
    width: 320,
  },
  [theme.breakpoints.down("xs")]: {
    width: 420,
  },
}));

export const ErrorButtonsContainer = styled("div")({
  display: "flex",
  justifyContent: "space-around",
  gap: 30,
});
